import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ClientRepository} from "@dropDesk/domain/repositories/client/client.repository";
import {CNPJResponseEntity} from "@dropDesk/domain/entities/common/cnpj_response.entity";

@injectable()
export class SearchCNPJClientUseCase {
    private _repository: ClientRepository;

    constructor(@inject(ClientRepository) repository: ClientRepository) {
        this._repository = repository;
    }

    public call(cnpj: string, idClient: string): Promise<CNPJResponseEntity> {
        return this._repository.searchByCNPJ(cnpj, idClient);
    }
}
